import { ReactElement } from 'react';
import BasicLayout from '../layouts/BasicLayout';
import SidebarFunc from '../layouts/BasicLayout/SidebarFunc';
import MobileVersionUpdatePopup from './views/MobileVersionUpdatePopup';


const MobileVersionRoute = (props: any): ReactElement => {
  const data=props.loginData;
  const permissions = props.permissions;
  var sidebarsData = SidebarFunc();
  return (
    <BasicLayout userData={data} permissions={permissions} sidebars={sidebarsData}>
      <MobileVersionUpdatePopup />
    </BasicLayout>
  )
};

export default MobileVersionRoute;
